import Authorization from "../../../../generics/authorization";
import ExecutiveSummary from ".";

const pageProps = {
  workflowContainer: true,
  dashlets: [{
    component: ExecutiveSummary,
    name: "ExecutiveSummary",
    layout: { x: 0, y: 0, w: 100, h: 40 }
  }]
};

const Page = () => (<Authorization pageProps={pageProps} />);

export default Page;
